import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrainingIndexComponent } from './crud-index/crud-index.component';
import { TrainingCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: TrainingIndexComponent,
  },
  {
    path: 'create',
    component: TrainingCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: TrainingCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: TrainingCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrainingsRoutingModule {}
